import { logger } from 'lib/logger';
import { appendQueryParams } from 'reactApp/utils/appendQueryParams';
import { getBase64FromBlob } from 'reactApp/utils/blob';

import { WorkspaceSuperAppService } from './WorkspaceSuperApp';

export class WorkspaceSuperAppSourceLoaderClass {
    private getHeaders(): Record<string, string> {
        const token = WorkspaceSuperAppService.getAuthToken();

        if (!token) {
            throw new Error('SuperApp token is not available');
        }

        return {
            Authorization: WorkspaceSuperAppService.getAuthHeaderValue(),
        };
    }

    async getAuthedResponse(src: string, noRedirect?: boolean) {
        const fetchSrc = noRedirect ? appendQueryParams(src, { no_redirect: 'true' }) : src;
        return fetch(fetchSrc, { headers: this.getHeaders() });
    }

    async getAuthedLink(src: string): Promise<string> {
        const response = await this.getAuthedResponse(src, true);
        const { redirect } = await response.json();
        return redirect;
    }

    async fetchImageAsBase64(src: string): Promise<string> {
        try {
            const headers = this.getHeaders();
            const urlWithParams = appendQueryParams(src, { no_redirect: 'true' });
            const response = await fetch(urlWithParams, { headers });
            const contentType = response.headers.get('content-type');

            let blob: Blob;

            if (contentType?.includes('application/json')) {
                const { redirect } = await response.json();
                const finalResponse = await fetch(redirect);
                blob = await finalResponse.blob();
            } else {
                blob = await response.blob();
            }

            return getBase64FromBlob(blob);
        } catch (error) {
            logger.error(error, '[WorkspaceSuperAppSourceLoader::fetchImageAsBase64]');
            throw error;
        }
    }
}

export const WorkspaceSuperAppSourceLoader = new WorkspaceSuperAppSourceLoaderClass();
